import { DataDonutChart, StackedBarProps } from '../components/dashboard/graph';
import { MapsData } from '../components/dashboard/map';
import { SessionsProps } from '../components/dashboard/sessions';
import { TopFiveProps } from '../components/dashboard/topFive';

export const devicesMock: StackedBarProps = {
  periods: ['Android'],
  data: {
    success: ['5'],
  },
  loading: false,
};

export const networkMock: StackedBarProps = {
  periods: ['STD'],
  data: {
    success: ['10'],
  },
  loading: false,
};

export const operationsMock: StackedBarProps = {
  periods: [
    '2:00AM',
    '3:00AM',
    '6:00AM',
    '9:00AM',
    '1:00PM',
    '5:00PM',
    '8:00PM',
    '9:00PM',
    '10:00PM',
  ],
  data: {
    Low: ['20', '25', '30', '35', '40', '45', '50', '55', '30'],
    Medium: ['15', '20', '25', '30', '35', '40', '45', '50', '45'],
    High: ['30', '15', '20', '25', '30', '35', '40', '45', '20'],
    Critical: ['25', '20', '15', '20', '25', '30', '35', '40', '20'],
  },
  loading: false,
};

export const riskMock: DataDonutChart[] = [
  { name: 'Shared Device', value: 25 },
  { name: 'Device with no sim', value: 40 },
  { name: 'Simultaneus Login', value: 35 },
];

export const mapMock: MapsData[] = [
  { color: 'success400', title: 'Europe', description: 'Sessions', count: 5 },
  { color: 'yellow400', title: 'America', description: 'Sessions', count: 2 },
];

export const sessionsMock: SessionsProps[] = [
  {
    iconName: 'Desktop',
    gradient: 'peach',
    count: 35,
    description: 'Web Sessions',
  },
  {
    iconName: 'DeviceMobile',
    gradient: 'bluePurple',
    count: 50,
    description: 'Mobile Sessions',
  },
];

export const topFiveMock: TopFiveProps[] = [
  {
    title: 'Top 5 User',
    data: [
      { id: 'User ID', value: 'Sessions' },
      { id: 'full-android-demo@facephi', value: 5 },
      { id: 'full-android-demo@facephi', value: 3 },
      { id: 'full-android-demo@facephi', value: 3 },
      { id: 'full-android-demo@facephi', value: 2 },
      { id: 'full-android-demo@facephi', value: 1 },
    ],
  },
  {
    title: 'Top 5 Devices',
    data: [
      { id: 'Device ID', value: 'Sessions' },
      { id: 'sadasd34543asd2r3', value: 5 },
      { id: 'csdc43f32fcb5badcv4', value: 3 },
      { id: 'cas4232c2asc32c31cq', value: 3 },
      { id: 'ec34v34vwrv34vv6n24v', value: 2 },
      { id: '3lk2njr3f2lnikniknpkf23i', value: 1 },
    ],
  },
  {
    title: 'Top 5 Networks',
    data: [
      { id: 'IP', value: 'Sessions' },
      { id: '345.768.290', value: 5 },
      { id: '651.761.29.280', value: 3 },
      { id: '509.872.65.354', value: 3 },
      { id: '987.761.29.280', value: 2 },
      { id: '651.761.29.842', value: 1 },
    ],
  },
  {
    title: 'Top Shared devices',
    data: [
      { id: 'Device ID', value: 'Sessions' },
      { id: 'sadasd34543asd2r3', value: 5 },
      { id: 'csdc43f32fcb5badcv4', value: 3 },
      { id: 'cas4232c2asc32c31cq', value: 3 },
      { id: 'ec34v34vwrv34vv6n24v', value: 2 },
      { id: '3lk2njr3f2lnikniknpkf23i', value: 1 },
    ],
  },
  {
    title: 'Top Shared networks',
    data: [
      { id: 'IP', value: 'Sessions' },
      { id: '345.768.290', value: 5 },
      { id: '651.761.29.280', value: 3 },
      { id: '509.872.65.354', value: 3 },
      { id: '987.761.29.280', value: 2 },
      { id: '651.761.29.842', value: 1 },
    ],
  },
];
